import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Table
} from 'reactstrap';
import ListInvoice from './ListInvoice';

const reorder = (rows, startIndex, endIndex) => {
  const result = Array.from(rows);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const ReactTableInvoicesCostumer = ({invoices ,invoiceChecks, setInvoiceChecks }) => {
  const [ data, setData] = useState(invoices);

  useEffect(()=>{
    
  }, []);
  
    
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
        <ListInvoice 
                  data={data}                   
                  invoiceChecks={invoiceChecks} 
                  setInvoiceChecks={setInvoiceChecks}
              />
        </CardBody>
      </Card>      
    </Col>
  );
};

ReactTableInvoicesCostumer.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default ReactTableInvoicesCostumer;
